import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

const FormCheckbox = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      type="checkbox"
      ref={ref}
      className={cn(
        'h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500',
        className
      )}
      {...props}
    />
  )
);
FormCheckbox.displayName = 'FormCheckbox';

export { FormCheckbox };
